export default "__VITE_ASSET__Cv22MZM6__"